var data = {
	"body": "<path d=\"M1006 216q-8-4-16.5-2.5T974 221L813 366 667 216 811 50q13-15 5-33-4-8-11.5-12.5T788 0h-8q-41 0-78 2.5T618 12t-86.5 23.5T468 77l-14 14q-35 36-53 87t-16 103.5 22 99.5L37 758Q0 796 0 849.5T37 941l45 46q38 37 90.5 37t90.5-37l374-378q14 7 29.5 13t31.5 10 32.5 6.5T762 641q101 0 175-75l13-14q22-21 37-55.5t22-63.5 10.5-73 4-62.5.5-53.5q-1-19-18-28zM906 509l-12 14q-18 18-39.5 30T810 571t-48 6q-19 0-41-4t-38-10q-30-13-55-36L218 941q-19 19-45.5 19T127 941l-45-46q-12-12-16.5-28.5t0-33.5T82 804l401-409q-19-28-28-63-7-33-6.5-68t13-70.5T497 134l14-14q27-28 86.5-41T720 62L603 197q-8 9-7.5 21.5T604 239l185 190q9 9 21 9.5t21-7.5l131-118q-10 148-56 196z\" fill=\"currentColor\"/>",
	"width": 1024,
	"height": 1024
};
exports.__esModule = true;
exports.default = data;



//////////////////
// WEBPACK FOOTER
// ./~/@iconify/icons-simple-line-icons/wrench.js
// module id = 476
// module chunks = 0